import { HttpErrorResponse } from '@angular/common/http';

import { Message } from './message.service';

interface QueryMessage {
  [key: string]: string;
}

interface MessageResponse {
  errorField?: string;
  query?: QueryMessage;
  response?: HttpErrorResponse;
  internalErrorMessage?: string;
}

export class MessageBuilder {
  private status: number;

  private data: MessageResponse;

  constructor(response?: HttpErrorResponse) {
    this.data = { response };
  }

  public static newInstance(response?: HttpErrorResponse): MessageBuilder {
    return new MessageBuilder(response);
  }

  public addStatus(status: number): MessageBuilder {
    this.status = status;
    return this;
  }

  public addErrorField(errorField: string): MessageBuilder {
    this.data.errorField = errorField;
    return this;
  }

  public addInternalErrorMessage(internalErrorMessage: string): MessageBuilder {
    this.data.internalErrorMessage = internalErrorMessage;
    return this;
  }

  public addQueryMessage(queryMessage: string, showMessage?: string): MessageBuilder {
    const { query } = this.data;
    this.data.query = { ...query, [queryMessage]: showMessage || queryMessage };
    return this;
  }

  public build(): Message {
    const { response, errorField, internalErrorMessage = 'Ops! Ocorreu um erro inesperado, tente novamente.' } = this.data;

    if (!response || !errorField) {
      return { status: this.status || response?.status, message: internalErrorMessage };
    }

    const error = response.error || {};
    const errorDescription = error[errorField];

    const query = this.data?.query || {};
    const message = query[errorDescription] || internalErrorMessage;

    return { status: this.status || response?.status, message };
  }
}
